import { ICart } from "../../../types/cart";
import { IGiftCard } from "../../../types/giftCard";
import { getCartFromCache } from "../../services/cart";
import {
  computeCartSubTotal,
  computeCartTotal,
} from "../../services/optimistic-response.service";

export interface IOptimisticResponse {
  __typename: "Mutation";
  cartGiftCardRemove: {
    __typename: "Cart";
  } & ICart;
}

export const getOptimisticResponse = (
  code: string
): IOptimisticResponse | {} => {
  const cart = getCartFromCache();

  let optimisticResponse = {};

  if (cart != null && cart.giftCards != null) {
    // Remove a gift card from the cart
    cart.giftCards = cart.giftCards.filter(
      (giftCard: IGiftCard) => giftCard.code !== code
    );

    const newSubTotal = computeCartSubTotal(cart.items);
    const newTotal = computeCartTotal(newSubTotal, cart.coupon, cart.giftCards);

    optimisticResponse = {
      __typename: "Mutation",
      cartGiftCardRemove: {
        __typename: "Cart",
        ...cart,
        giftCards: cart.giftCards,
        subTotal: newSubTotal,
        total: newTotal,
      },
    };
  }

  return optimisticResponse;
};
